import type {
  AiOrSampleDisplayImage,
  AiOrSampleGeneratedImage,
  DesignerProduct,
} from '../../types';
import { isAiDisplay, isAiGenerated, isDisplay, pickImage } from '../../types';

export const productTrackingData = (
  palette: string,
  product: DesignerProduct,
) => ({
  product_group: palette,
  product_name: product.primaryLabel,
  parameter: '', // parameter is "required" but is not relevant in this context
  product: '', // product is "required" but is not relevant in this context
  selection: '', // selection is "required" but is not relevant in this context
});

export const imageTracking = (
  image: AiOrSampleGeneratedImage | AiOrSampleDisplayImage | null | undefined,
) => {
  const pickedImage = pickImage(image);

  return {
    ...(isAiGenerated(pickedImage)
      ? {
          ai_original_image_id: pickedImage.aiOriginalImageId,
          ai_generated_image_id: pickedImage.id,
          ai_display_image_id: undefined,
          style: undefined,
          space_type: undefined,
        }
      : undefined),
    ...(isDisplay(image) && isAiDisplay(image)
      ? {
          ai_original_image_id: undefined,
          ai_generated_image_id: undefined,
          ai_display_image_id: image.id,
          style: image.style ?? undefined,
          space_type: image.spaceType ?? undefined,
        }
      : undefined),
  };
};

/**
 * Generates a record according to the operation
 * is it saving or removing
 *
 * @param {string} name - the name to be used in the record
 * @param {boolean} isSaving - flag indicating if the property is saving
 * @return {Record<string, string>} - the generated record
 */
export const getReferredProperty = (
  name: string,
  isSaving: boolean,
): Record<string, string> =>
  isSaving ? { saved_to: name } : { removed_from: name };
